




































import { Component, Prop, Vue } from "vue-property-decorator";
import ImageString from "@/components/ImageString.vue";
import QuestionModel from "@/model/QuestionModel";
import AttemptModule from "@/store/AttemptModule";

@Component({
  components: { ImageString }
})
export default class Question extends Vue {
  @Prop()
  question!: QuestionModel;

  @Prop()
  questionIndex!: number;

  @Prop()
  questionCount!: number;

  onAnswerChanged(questionUuid: string, answerUuid: string, checked: boolean) {
    localStorage.setItem(questionUuid, answerUuid);
    AttemptModule.saveAnswers(AttemptModule.getAttempt);
  }
}
